import { useCallback, useMemo } from 'react';
import { ApolloError } from '@apollo/client/errors';
import { FetchResult } from '@apollo/client';
import {
  UpdateSettingPreferencesForCollectorSettingMutation,
  UpdateSettingPreferencesForCollectorSettingInput,
  useUpdateSettingPreferencesForCollectorSettingMutation
} from 'graphql/types';
export const useUpdateSettingPreferencesForCollectorSetting = (): {
  updateSettingPreferences: (
    input: UpdateSettingPreferencesForCollectorSettingInput
  ) => Promise<
    FetchResult<
      UpdateSettingPreferencesForCollectorSettingMutation,
      Record<string, any>,
      Record<string, any>
    >
  >;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const [
    updateSettingPreferencesForCollectorSettingMutation,
    { loading, error }
  ] = useUpdateSettingPreferencesForCollectorSettingMutation();

  const updateSettingPreferences = useCallback(
    async (input: UpdateSettingPreferencesForCollectorSettingInput) =>
      await updateSettingPreferencesForCollectorSettingMutation({
        variables: {
          input
        }
      }),
    [updateSettingPreferencesForCollectorSettingMutation]
  );
  return useMemo(
    () => ({
      updateSettingPreferences,
      loading,
      error
    }),
    [updateSettingPreferences, loading, error]
  );
};
